import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import Modal from "../modal/Modal";
import { Image as ImageJss } from "@sitecore-jss/sitecore-jss-react";
import { QRCodeSVG } from "qrcode.react";
import { scImageType, scStringType } from "../../types";
import { getLoyaltyStorage } from "../../util";
import { useFlags } from 'launchdarkly-react-client-sdk';

var MemberIdModal = function MemberIdModal(props) {
  var _ref = (props === null || props === void 0 ? void 0 : props.model) || {},
      MemberLoyalty = _ref.MemberLoyalty,
      Copy = _ref.Copy,
      Image = _ref.Image;

  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      memberName = _useState4[0],
      setMemberName = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      memberSince = _useState6[0],
      setMemberSince = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      memberEmail = _useState8[0],
      setMemberEmail = _useState8[1];

  var loyaltyStorage = getLoyaltyStorage();
  useEffect(function () {
    window.addEventListener("openMemberIdModal", function () {
      setIsOpen(true);
    });

    var _ref2 = (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : loyaltyStorage.account) || {},
        FirstName = _ref2.FirstName,
        LastName = _ref2.LastName,
        Email = _ref2.Email,
        EnrolledAt = _ref2.EnrolledAt;

    if (FirstName || LastName) {
      setMemberName("".concat(FirstName, " ").concat(LastName));
    }

    if (Email) {
      setMemberEmail(Email);
    }

    if (EnrolledAt) {
      var date = new Date(EnrolledAt);
      setMemberSince(date.getFullYear() || null);
    }

    return function () {
      window.removeEventListener("openMemberIdModal", function () {});
    };
  }, []);

  var handleHide = function handleHide() {
    setIsOpen(false);
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: "loyalty-modal member-id-modal",
    show: isOpen,
    hide: handleHide,
    hideCloseButton: true,
    title: /*#__PURE__*/React.createElement(ImageJss, {
      field: Image.value
    }),
    backdrop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "member-id-modal__body"
  }, /*#__PURE__*/React.createElement("span", {
    className: "member-id-modal__name"
  }, memberName || 'Member Name'), /*#__PURE__*/React.createElement("div", {
    className: "member-id-modal__qr"
  }, /*#__PURE__*/React.createElement(QRCodeSVG, {
    size: 155,
    fgColor: useNewRebrandStyles ? '#2B1D10' : '#4a2308',
    value: "CBL-".concat(memberEmail)
  })), /*#__PURE__*/React.createElement("span", {
    className: "member-id-modal__loyalty"
  }, (MemberLoyalty === null || MemberLoyalty === void 0 ? void 0 : MemberLoyalty.value) || 'Member Since', " ", memberSince || '2025')), (Copy === null || Copy === void 0 ? void 0 : Copy.value) ? /*#__PURE__*/React.createElement("p", {
    className: "member-id-modal__copy"
  }, Copy === null || Copy === void 0 ? void 0 : Copy.value) : null);
};

export default MemberIdModal;